export function nameCsvFile(resourceName: string): string {
  return `${resourceName}.csv`;
}

export function nameCsvFileWithResourceId(
  resourceName: string,
  resourceId: string,
): string {
  return `${resourceName}-${resourceId}.csv`;
}
